export default {"src":"/_next/static/media/mini_trade_card_bg.d5437c95.gif","height":300,"width":300,"blurWidth":0,"blurHeight":0};